/* global moment swal angular _ */

import './style.less';
import { uniq, keyBy, orderBy } from 'lodash';

export default function($log, $scope, $stateParams, $filter, Swal, ApiClass, HelperClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;
  vm.profile_uid = $stateParams.id;

  vm.archive = activity => {
    const formData = angular.copy(activity);
    formData.archived = true;
    Swal.confirm('Archive the activity?', 'Are you sure? This will remove the activity completely.', 'warning')
      .then(() => ApiClass.activitiesIdPatch({ id: formData.uuid, manage: true }, formData))
      .then(() => activate())
      .catch(error => {
        if (error.dismiss) return;
        $log.error(error);
        swal('Hold Up!', 'Somethings not quite right, please try again', 'error');
        throw error;
      });
  };

  vm.status = (activity, status = false) => {
    const formData = angular.copy(activity);
    formData.active = status;

    const { title, text } = status
      ? {
          title: 'Ready to publish?',
          text: 'This will make the activity visible to all users in the activity library.'
        }
      : {
          title: 'Unpublish the activity?',
          text:
            'The activity will no longer be available, including users that are in progress or have already completed it.'
        };
    Swal.confirm(title, text)
      .then(() => {
        return ApiClass.activitiesIdPatch({ id: formData.uuid, manage: true }, formData);
      })
      .then(() => {
        Swal.toast('Activity has been updated');
        activity.active = status;
      })
      .catch(error => {
        if (error.dismiss) return;
        $log.error(error);
        Swal.toast('Hold Up!, Somethings not quite right, please try again', 'error');
        throw error;
      });
  };

  vm.inviteOnly = (activity, inviteOnly = false) => {
    const formData = angular.copy(activity);
    formData.inviteOnly = inviteOnly;

    const { title, text } = inviteOnly
      ? {
          title: 'Hide From Library?',
          text:
            'Enabling this setting will prevent the published activity from showing in the library. Only those who are assigned the activity will be able to view it'
        }
      : {
          title: 'Show in Library?',
          text: 'This will make a published activity visible to all users in the activity library.'
        };
    Swal.confirm(title, text)
      .then(() => ApiClass.activitiesIdPatch({ id: formData.uuid, manage: true }, formData))
      .then(() => {
        Swal.toast('Activity has been updated');
        activity.inviteOnly = inviteOnly;
      })
      .catch(error => {
        if (error.dismiss) return;
        $log.error(error);
        Swal.toast('Hold Up!, Somethings not quite right, please try again', 'error');
        throw error;
      });
  };

  vm.copySupported = false;

  vm.copySuccess = () => {
    Swal.toast('Copied');
  };

  vm.copyFail = error => {
    $log.error(error);
    throw error;
  };

  vm.copyUrl = activity_id => {
    const domain = HelperClass.getDomain();

    return `${domain}/activities/${activity_id}`;
  };

  function activate() {
    $log.debug('Admin Activities Activated');
    vm.loaded = false;
    vm.error = {};

    delete vm.activities;
    delete vm.activitiesDict;
    delete vm.authorGroup;

    ApiClass.activitiesGet(
      { profile_uid: $stateParams.id, manage: true },
      {},
      {
        queryParams: {
          filters: JSON.stringify({
            basic: true
          }),
          includes: JSON.stringify({
            profiles: false,
            progress: false
          })
        }
      }
    )
      .then(({ data: { items: activities } }) => {
        $log.debug('Admin Activities Data', activities);

        vm.activities = orderBy(activities, ['sortDate'], ['desc']);
        vm.activitiesDict = keyBy(activities, 'uuid');
        vm.authorGroup = uniq(activities.map(({ author }) => author));

        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };

        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/author/activities/get/controller.js